import React from 'react'
import { Select, Space, Typography, theme, Tooltip } from 'antd'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faLanguage } from '@fortawesome/free-solid-svg-icons'
import { getLanguageOptions, getLanguageName, SA_OFFICIAL_LANGUAGES } from '../utils/languageConfig'

const { Text } = Typography

const LanguageSelector = ({
  selectedLanguage,
  onLanguageChange,
  disabled = false,
  size = 'small',
  showLabel = true
}) => {
  const { token } = theme.useToken()

  const languageOptions = getLanguageOptions()

  // Group South African languages at the top
  const saLanguages = languageOptions.filter((option) => SA_OFFICIAL_LANGUAGES.includes(option.value))
  const otherLanguages = languageOptions.filter((option) => !SA_OFFICIAL_LANGUAGES.includes(option.value))

  const groupedOptions = [
    {
      label: <span style={{ fontWeight: 'bold', color: token.colorPrimary }}>🇿🇦 South African Languages</span>,
      options: saLanguages
    },
    {
      label: <span style={{ fontWeight: 'bold', color: token.colorTextSecondary }}>🌍 Other Languages</span>,
      options: otherLanguages
    }
  ]

  const handleLanguageChange = (value) => {
    if (onLanguageChange) {
      onLanguageChange(value)
      // Show a brief success message
      console.log(`Language changed to: ${getLanguageName(value)}`)
    }
  }

  return (
    <Space size={8} align='center'>
      {showLabel && (
        <Tooltip title="Select the language you'll be speaking in (your preference will be saved)">
          <Space size={4} align='center'>
            <FontAwesomeIcon
              icon={faLanguage}
              style={{
                color: disabled ? token.colorTextDisabled : token.colorTextSecondary,
                fontSize: '14px'
              }}
            />
            <Text
              style={{
                fontSize: '12px',
                color: disabled ? token.colorTextDisabled : token.colorTextSecondary,
                fontWeight: '500'
              }}
            >
              Language:
            </Text>
          </Space>
        </Tooltip>
      )}

      <Select
        value={selectedLanguage}
        onChange={handleLanguageChange}
        disabled={disabled}
        size={size}
        style={{
          minWidth: '140px',
          opacity: disabled ? 0.6 : 1
        }}
        placeholder='Select language'
        showSearch
        optionFilterProp='searchLabel'
        filterOption={(input, option) => option.searchLabel?.toLowerCase().includes(input.toLowerCase())}
        dropdownStyle={{
          maxHeight: '300px'
        }}
      >
        {groupedOptions.map((group, groupIndex) => (
          <Select.OptGroup key={groupIndex} label={group.label}>
            {group.options.map((option) => (
              <Select.Option key={option.value} value={option.value} searchLabel={option.searchLabel}>
                {option.label}
              </Select.Option>
            ))}
          </Select.OptGroup>
        ))}
      </Select>

      {selectedLanguage && (
        <Text
          style={{
            fontSize: '11px',
            color: token.colorTextTertiary,
            fontStyle: 'italic'
          }}
        >
          {getLanguageName(selectedLanguage)}
        </Text>
      )}
    </Space>
  )
}

export default LanguageSelector
